import { useEffect } from 'react'
import { HttpStatusCode } from 'axios/index'

const ReigniteSseHub = ({
  asOf,
  onMessage,
  updateIsLoading,
  params
}: {
  asOf: number
  onMessage: (parsed: { data: any, status: HttpStatusCode }) => void
  updateIsLoading: (value: boolean) => void
  params: {
    path: string
    url: string
  }
}) => {
  const {
    path,
    url,
  } = params
  const encodedUrl = encodeURIComponent(url)
  useEffect(() => {
    updateIsLoading(true)
    const eventSource = new EventSource(`${process.env.REACT_APP_REIGNITE_SSE_URL}/hub/${path}?url=${encodedUrl}`)

    eventSource.addEventListener('multicast', (event) => {
      const parsed = JSON.parse(event.data)
      console.info('Event Hub received:', parsed)
      onMessage(parsed)
      updateIsLoading(false)
    })

    eventSource.addEventListener('error', (error) => {
      console.error('Error with Event Hub:', error)
      updateIsLoading(false)
    })

    return () => {
      eventSource.close()
    }
  }, [
    asOf,
    encodedUrl,
    onMessage,
    path,
    updateIsLoading,
  ])

  return (<div />)
}

export default ReigniteSseHub
